var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-text',{attrs:{"content":_vm.supplier,"title":_vm.supplier}})}
var staticRenderFns = []

export { render, staticRenderFns }